export default __webpack_public_path__ + "media/images/mailer/wordmark-dce9ea8552976c276384b8a9a852f33e.png";